module.exports = __webpack_public_path__ + "7dfad5e44cf6341f87ec2c1a4c6ce6a6.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Glyphter.woff
// module id = as5Q
// module chunks = 0